/**
 * Utilitaires pour les notes et avis
 */

/**
 * Calcule la note moyenne à partir d'une distribution de notes
 */
export function calculateAverageRating(ratingDistribution: {
  5: number;
  4: number;
  3: number;
  2: number;
  1: number;
}): number {
  const total = Object.values(ratingDistribution).reduce((sum, count) => sum + count, 0);
  if (total === 0) return 0;

  const weightedSum = 
    (ratingDistribution[5] * 5) +
    (ratingDistribution[4] * 4) +
    (ratingDistribution[3] * 3) +
    (ratingDistribution[2] * 2) +
    (ratingDistribution[1] * 1);

  return Math.round((weightedSum / total) * 10) / 10; // Arrondi à 1 décimale
}

/**
 * Note moyenne par défaut (pour les données mockées)
 * Cette valeur doit être cohérente partout dans l'application
 */
export const DEFAULT_AVERAGE_RATING = 4.7;

